import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Apps, ProjectCreateTitle } from "../../../../constants";
import ProjectForm from "./ProjectForm";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

const CreateProjectContainer = () => {

  return (
    <>
      <Breadcrumbs mainTitle={ProjectCreateTitle} parent={Apps} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <ProjectForm />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreateProjectContainer;